var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Typography, TableContainer as MuiTableContainer, Table, TableBody, TableCell, TableHead, TableRow, Toolbar as MuiToolbar, Paper, } from '@mui/material';
import Papa from 'papaparse';
import Button from '../atoms/BaseButton';
import FileField from '../atoms/FileField';
import { ErrorIcon, SuccessIcon, UploadIcon } from '../atoms/Icons';
import FullScreenDialog from '../molecules/FullScreenDialog';
import { useNotify } from '../../hooks/notificationHook';
import { update as updateDeliveryRequest } from '../../api/deliveryRequest';
import { ResponseError } from '../../api/request';
import LinearProgressWithLabel from '../atoms/LinearProgressWithLabel';
import { green, red } from '@mui/material/colors';
var parseCsv = function (file) {
    return new Promise(function (resolve) {
        Papa.parse(file, {
            complete: function (results) {
                resolve(results);
            },
        });
    });
};
var CsvColumnsMap = {
    id: 0,
    trackingNumber: 1,
    deliveryFee: 2,
    status: 3,
    deliveredDate: 4,
};
var buildRowData = function (row) {
    return {
        id: row[CsvColumnsMap['id']],
        trackingNumber: row[CsvColumnsMap['trackingNumber']],
        deliveryFee: row[CsvColumnsMap['deliveryFee']],
        status: row[CsvColumnsMap['status']],
        deliveredDate: row[CsvColumnsMap['deliveredDate']],
    };
};
var TableContainer = styled(MuiTableContainer).attrs({
    component: Paper,
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .MuiTableCell-head {\n    white-space: nowrap;\n  }\n"], ["\n  & .MuiTableCell-head {\n    white-space: nowrap;\n  }\n"])));
var Toolbar = styled(MuiToolbar)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & > div,\n  & > button {\n    margin-right: 16px;\n  }\n"], ["\n  & > div,\n  & > button {\n    margin-right: 16px;\n  }\n"])));
var ResultCell = function (_a) {
    var row = _a.row;
    return (React.createElement(TableCell, { style: { color: row.errors.length > 0 ? red[500] : green[500] } },
        row.done && row.errors.length === 0 && React.createElement(SuccessIcon, null),
        row.done && row.errors.length > 0 && (React.createElement("div", null,
            React.createElement(ErrorIcon, null),
            row.errors.map(function (error) { return (React.createElement(Typography, { key: error, style: { whiteSpace: 'nowrap' } }, error)); })))));
};
var ImportDeliveryRequestsButton = function (_a) {
    var onComplete = _a.onComplete;
    var _b = React.useState(false), importDialogOpen = _b[0], setImportDialogOpen = _b[1];
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useState([]), rows = _d[0], setRows = _d[1];
    var t = useTranslation().t;
    var notify = useNotify();
    var statusMap = React.useMemo(function () {
        var map = t('params.deliveryRequest.statuses', {
            returnObjects: true,
        });
        return Object.fromEntries(Object.entries(map).map(function (_a) {
            var k = _a[0], v = _a[1];
            return [v, k];
        }));
    }, [t]);
    var resetDialogState = React.useCallback(function () {
        setImportDialogOpen(false);
        setRows([]);
    }, []);
    var parseAndDisplayCsv = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var file, parseResult, set_1, nextRows;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    file = event.target.files[0];
                    if (!file)
                        return [2 /*return*/];
                    return [4 /*yield*/, parseCsv(event.target.files[0])];
                case 1:
                    parseResult = _a.sent();
                    if (parseResult.errors.length > 0) {
                        set_1 = new Set();
                        parseResult.errors.forEach(function (error) {
                            return set_1.add("[line: ".concat(error.row, "] ").concat(error.message));
                        });
                        notify('error', Array.from(set_1));
                        return [2 /*return*/];
                    }
                    nextRows = parseResult.data
                        .slice(1)
                        .map(function (row) {
                        return {
                            done: false,
                            errors: [],
                            data: buildRowData(row),
                        };
                    })
                        .filter(function (row) { return row.data.id; });
                    setRows(nextRows);
                    return [2 /*return*/];
            }
        });
    }); }, [notify]);
    var startToImport = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var index, data, nextRows, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    index = 0;
                    _a.label = 1;
                case 1:
                    if (!(index < rows.length)) return [3 /*break*/, 7];
                    data = rows[index].data;
                    nextRows = __spreadArray([], rows, true);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, updateDeliveryRequest({
                            id: data.id,
                            delivery_request: {
                                tracking_number: data.trackingNumber,
                                delivery_fee: data.deliveryFee,
                                status: statusMap[data.status] || '',
                                delivered_date: data.deliveredDate,
                            },
                        })];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (error_1 instanceof ResponseError) {
                        nextRows[index].errors = error_1.getErrors();
                    }
                    else if (error_1 instanceof Error) {
                        nextRows[index].errors = [error_1.message];
                    }
                    else {
                        nextRows[index].errors = ['unknown error'];
                    }
                    return [3 /*break*/, 5];
                case 5:
                    nextRows[index].done = true;
                    setRows(nextRows);
                    _a.label = 6;
                case 6:
                    index += 1;
                    return [3 /*break*/, 1];
                case 7:
                    setLoading(false);
                    onComplete();
                    return [2 /*return*/];
            }
        });
    }); }, [rows, statusMap, onComplete]);
    var completedCount = rows.filter(function (row) { return row.done; }).length;
    var totalCount = rows.length;
    var progress = totalCount > 0 ? Math.floor((completedCount / totalCount) * 100) : 0;
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: function () { return setImportDialogOpen(true); } },
            React.createElement(UploadIcon, null),
            React.createElement("span", { style: { marginLeft: 10 } }, t('buttons.import'))),
        React.createElement(FullScreenDialog, { title: t('pages.deliveryRequests.import'), open: importDialogOpen, onClose: resetDialogState, keepMounted: false },
            React.createElement(Toolbar, null,
                React.createElement(FileField, { label: t('buttons.chooseFile'), name: "file", onChange: parseAndDisplayCsv }),
                React.createElement(Button, { onClick: startToImport, disabled: loading || rows.length === 0 }, t('buttons.upload'))),
            rows.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(LinearProgressWithLabel, { label: "".concat(completedCount, " / ").concat(totalCount), value: progress }),
                React.createElement(TableContainer, null,
                    React.createElement(Table, { size: "small" },
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, null,
                                React.createElement(TableCell, null, "Result"),
                                Object.keys(CsvColumnsMap).map(function (key) { return (React.createElement(TableCell, { key: key }, t("params.deliveryRequest.".concat(key), '') ||
                                    t("params.".concat(key)))); }))),
                        React.createElement(TableBody, null, rows.map(function (row) { return (React.createElement(TableRow, { key: row.data.id },
                            React.createElement(ResultCell, { row: row }),
                            Object.entries(row.data).map(function (_a) {
                                var key = _a[0], value = _a[1];
                                return (React.createElement(TableCell, { key: key }, value));
                            }))); })))))))));
};
export default ImportDeliveryRequestsButton;
var templateObject_1, templateObject_2;
